import React from 'react';
import { useSelector } from 'react-redux';
import { colorsConsumptionByIncome } from '../../../../shared/constants';
import { GenericChartCard } from '../../../../component/charts/genericChartCard';
import { ErrorState } from './errorState';
import { generateTitleAndSource } from './socioeconomicDemographicCharts';
import nls from '../nls/pt-BR.json';
import { useSocioeconomicChartsData } from '../../../../hooks/useSocioeconomicChartsData';

export const ConsumptionByIncome: React.FC = () => {
  const { errorFetchData } =
    useSelector((state: any) => state.socioeconomicDemographicState) || '';
  const { consumptionByIncome } = useSocioeconomicChartsData();

  return (
    <GenericChartCard
      title={generateTitleAndSource(
        nls.charts.consumptionByIncome.consumptionByIncome,
        nls.disclaimers.dataSourceIBGE2010
      )}
    >
      {errorFetchData?.consumptionByIncome ? (
        <ErrorState />
      ) : (
        <table>
          {Object.keys(consumptionByIncome || [])
            .reverse()
            .map((key: string, index: number) => {
              return (
                <tr key={index}>
                  <td>
                    <div
                      style={{
                        backgroundColor: colorsConsumptionByIncome[index],
                      }}
                      className="color-consumption"
                    />
                    {key}
                  </td>
                  <td>{consumptionByIncome[key]?.average_consumption}</td>
                </tr>
              );
            })}
        </table>
      )}
    </GenericChartCard>
  );
};
